/* global JSX */
//ToolButton
//***********************************************************************************************************************
import * as React from "react";
import { Base } from "./../../framework/base";
import { Button } from "./button";
import { DropdownMenu, IDropdownAction } from "./dropdown";

export interface IToolButtonProp {
    removeDefaultClasses?: boolean;
    stopPropagation?: boolean;
    title?: string | JSX.Element;
    classes?: string;
    tooltip?: string;
    disabled?: boolean;
    onClick: () => void;
}

export class ToolButton extends React.Component<IToolButtonProp, {}> {
    handleClick = (e) => {
        const props = this.props;
        if (!!props.disabled || !props.onClick) return;
        if (props.stopPropagation) {
            e.stopPropagation();
        }
        Button.callOnClick(props.onClick);
    };

    render() {
        const props = this.props;
        const hasTitle = !!props.title;
        const tooltip = props.tooltip ? props.tooltip : (typeof props.title === "string" ? props.title : null);
        const buttonClasses = (props.removeDefaultClasses ? "" : "btn btn-tool") + (props.classes ? " " + props.classes : "") + (props.disabled ? " disabled" : "") + (hasTitle ? " text" : "");
        return (
            <button type="button" className={buttonClasses} title={tooltip} onClick={this.handleClick}><span className="icon" aria-hidden="true"></span>{hasTitle && <br />}{props.title}</button>
        );
    }
}

export interface IToolAddFileButtonProp {
    removeDefaultClasses?: boolean;
    stopPropagation?: boolean;
    accept?: string;
    title?: string | JSX.Element;
    tooltip?: string;
    classes?: string;
    disabled?: boolean;
    fileInputName: string;
    onChange: (fileList: FileList) => void;
}

export class ToolAddFileButton extends React.Component<IToolAddFileButtonProp, {}> {
    handleClick = (e) => {
        const props = this.props;
        if (props.stopPropagation) {
            e.stopPropagation();
        }
    };

    handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const props = this.props;
        if (props.disabled) return;
        if (props.stopPropagation) {
            e.stopPropagation();
        }
        if (!e.target.files || e.target.files.length < 1) return;
        this.props.onChange(e.target.files);
    };

    render() {
        const props = this.props;
        const hasTitle = !!props.title;
        const tooltip = props.tooltip ? props.tooltip : (typeof props.title === "string" ? props.title : null);
        const buttonClasses = (props.removeDefaultClasses ? "" : "btn btn-tool") + (props.classes ? " " + props.classes : "") + (props.disabled ? " disabled" : "") + (hasTitle ? " text" : "");
        if (!props.disabled) {
            return (
                <label className={buttonClasses} title={tooltip} onClick={this.handleClick}>
                    <span className="icon" aria-hidden="true">
                        <input type="file" name={this.props.fileInputName} className="file" style={{ display: "none" }} multiple={true} accept={props.accept} onChange={this.handleChange} />{hasTitle && <br />}{props.title}
                    </span>
                </label>
            );
        }
        return (
            <button type="button" className={buttonClasses} title={tooltip}><span className="icon" aria-hidden="true"></span>{hasTitle && <br />}{props.title}</button>
        );
    }
}

export interface IToolButtonDropdownProp {
    actions: IDropdownAction[];
    buttonClasses?: string;
    classes?: string;
    disabled?: boolean;
    menuRight?: boolean;
    removeDefaultClasses?: boolean;
    stopPropagation?: boolean;
    title?: string | JSX.Element;
    tooltip?: string;
}

export interface IToolButtonDropdownState {
    open: boolean;
}

export class ToolButtonDropdown extends React.Component<IToolButtonDropdownProp, IToolButtonDropdownState> {
    _isMounted: boolean;
    dropdownId: string;

    constructor(props: IToolButtonDropdownProp) {
        super(props);
        this.dropdownId = Base.getGuid();
        this.state = {
            open: false
        };
    }

    dropdownClickEvent = (ev: MouseEvent) => {
        if (!this._isMounted) return;
        const element = ev.target as HTMLElement;
        const multiSelect = element.closest("[data-id='" + this.dropdownId + "']");
        if (!multiSelect) {
            this.setState({
                open: false
            });
        }
    };

    componentDidMount(): void {
        window.addEventListener("click", this.dropdownClickEvent, true);
        this._isMounted = true;
    }

    componentWillUnmount(): void {
        this._isMounted = false;
        window.removeEventListener("click", this.dropdownClickEvent);
    }

    handleToggleDropdown = () => {
        if (this.props.disabled) return;
        const obj = this;
        Button.callOnClick(() => {
            if (!this._isMounted) return;
            obj.setState({
                open: !obj.state.open
            });
        });
    };

    handleActionClick = (ev: React.MouseEvent, action: IDropdownAction) => {
        ev.preventDefault();
        if (!action) return;
        if (action.disabled) return;
        this.handleToggleDropdown();
        action.onClick();
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <div data-id={this.dropdownId} className={"btn-group dropdown-tool" + (props.classes ? " " + props.classes : "")}>
                <ToolButton
                    removeDefaultClasses={props.removeDefaultClasses}
                    stopPropagation={props.stopPropagation}
                    title={props.title}
                    classes={props.buttonClasses ? " " + props.buttonClasses : ""}
                    tooltip={props.tooltip}
                    disabled={props.disabled}
                    onClick={this.handleToggleDropdown}
                />
                {state.open &&
                    <DropdownMenu
                        actions={props.actions}
                        menuRight={props.menuRight}
                        selectMode={false}
                        onToggleDropodown={this.handleToggleDropdown}
                    />
                }
            </div>

        );
    }
}
